import { buttonIdleAnimation } from '../../Animations/UIAnimations';
import { IconTextButton } from './IconTextButton';
import { ButtonColors } from './NineSliceButton';

export class AskFrButton extends IconTextButton {
    constructor(width: number, height: number, btnText: string) {
        super({
            width,
            height,
            btnText,
            color: ButtonColors.PINK,
            outline: 0x991f33,
            iconId: 'commonui/button-icon-invite',
        });

        buttonIdleAnimation(this, 2);
    }
}
